import React from 'react';
import './Position.css';

import { Button } from '../../components';

import { FaDollarSign } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';

import { Link } from 'react-router-dom';



const Position = ({ position }) => {

  return (

    /* Container for each job position item */
    <div className='position-item' key={position.id}>

      <div className='content'>

        <span>{position.details.timing}</span> {/* Job Timing */}

        {/* Link to the individual job position page */}
        <Link
          to={{
            pathname: '/Careers/' + position.title,  // Navigate to specific job position page
          }}
          state={position}  // Pass position details to the linked page
          className='main-heading' >
          <h3>{position.title}</h3> {/* Job title */}
        </Link>

        <div className='details'>
          <h5><FaLocationDot className='icon' /><span>{position.details.location}</span></h5> {/* Job Location */}
          <h5><FaDollarSign className='icon' /><span>{position.details.salary}</span></h5> {/* Job Salary  */}
        </div>

      </div>

      <Button link={'Career-Form'} title={'Apply Now'} /> {/* 'Apply Now' button which redirects to the career form */}

    </div>

  );
};

export default Position;